function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MessageEnum, { getName } from '../Messages/MessageEnum';
import { runEngine } from '../RunEngine';
import { Message } from '../Message';
import { Block } from '../Block';
import StorageProvider from '../StorageProvider';
export default class AuthManagerBlock extends Block {
  constructor() {
    super();
    _defineProperty(this, "userCredsKey", 'saveUserInfo');
    runEngine.attachBuildingBlock(this, [getName(MessageEnum.AuthenticateUserMessage), getName(MessageEnum.LoginFaliureMessage), getName(MessageEnum.RequestUserSession)]);
  }
  static getInstance() {
    if (!AuthManagerBlock.instance) {
      AuthManagerBlock.instance = new AuthManagerBlock();
    }
    return AuthManagerBlock.instance;
  }
  async receive(from, message) {
    switch (message.id) {
      case getName(MessageEnum.AuthenticateUserMessage):
        {
          const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
          requestMessage.initializeFromObject(message.properties);
          break;
        }
      case getName(MessageEnum.RequestUserSession):
        {
          break;
        }
    }
  }
  async saveUserData(countryCode, userName, password, isRememberMe) {
    if (!isRememberMe) {
      this.clearUserData();
    } else {
      try {
        const userInfo = {
          id: userName,
          countrycode: countryCode,
          password: password
        };
        await StorageProvider.set(this.userCredsKey, JSON.stringify(userInfo));
        this.countryCode = countryCode;
        this.userName = userName;
      } catch (_unused) {}
    }
  }
  async clearUserData() {
    await StorageProvider.set(this.userCredsKey, '');
    this.userName = null;
    this.countryCode = null;
  }
}